<div class="analytics-form-container">
  <mat-dialog-content>
    <div class="title">
      <app-title-field
        [title]="dialogData?.isEdit ? 'Edit' : 'Add New'"
      ></app-title-field>
      <div class="close-button" type="button" (click)="closeForm()">
        <app-title-field [icon]="'close'" [title]="' '"></app-title-field>
      </div>
    </div>
    <div class="form-section">
      <form
        [formGroup]="DamageAnalyticsForm"
        (ngSubmit)="$event.preventDefault()"
        class="form-section"
      >

           <div class="form-row">
          <div class="input-item">
            <app-input-field
              *ngIf="dialogData?.isEdit"
              [label]="'Resource Email ID'"
              [type]="'email'"
              [required]="true"
              [disabled]="true"
              [cssClass]="'input-fields'"
              formControlName="email"
            ></app-input-field>
            <div *ngIf="!dialogData?.isEdit" class="email-search-container">
              <mat-form-field appearance="outline" class="email-input-field">
                <mat-label>Resource Email ID</mat-label>
                <input
                  matInput
                  formControlName="email"
                  (input)="onEmailInput($event)"
                  placeholder="Search"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="onEmailChange($event.option.value)"
                >
                  <mat-option
                    *ngFor="let option of emailOptions"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="input-item">
            <app-input-field
              [label]="'PSID'"
              [type]="'text'"
              [cssClass]="'input-fields'"
              formControlName="employeeId"
              [disabled]="true"
            ></app-input-field>
          </div>
        </div>
        <div class="form-row">
          <div class="input-item">
            <app-dropdown
              class="emerald-dropdown dropdown-cls"
              [isOutlined]="true"
              [label]="'Laptop Type'"
              [options]="assetsOptions"
              [displayKey]="'label'"
              [valueKey]="'value'"
              formControlName="osType"
              [disabled]="true"
            ></app-dropdown>
          </div>
          <div class="input-item">
            <app-input-field
              [label]="'Damage Cost'"
              [type]="'number'"
              [required]="true"
              [cssClass]="'input-fields'"
              formControlName="damageCost"
            ></app-input-field>
          </div>
        </div>
   

        <div class="form-row">
          <div class="input-item">
            <app-input-field
              [label]="'Resource name'"
              [type]="'text'"
              [cssClass]="'input-fields'"
              formControlName="fullName"
              [disabled]="true"
            ></app-input-field>
          </div>
          <div class="input-item">
            <app-input-field
              [label]="'Company'"
              [type]="'text'"
              [cssClass]="'input-fields'"
              formControlName="employer"
              [disabled]="true"
            ></app-input-field>
          </div>
        </div>
        <div class="form-row">
          <div class="input-item date-picker-joining">
            <mat-form-field class="form-input" appearance="outline" floatLabel="always">
              <mat-label>Date of Joining</mat-label>
              <input matInput [matDatepicker]="pickerDateOfJoining" formControlName="dateOfJoining" placeholder="MM/DD/YYYY" [disabled]="true">
              <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfJoining" [disabled]="true"></mat-datepicker-toggle>
              <mat-datepicker #pickerDateOfJoining></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="input-item">
            <mat-form-field class="required-field form-input" appearance="outline" floatLabel="always">
              <mat-label>Date of Issue</mat-label>
              <input matInput [matDatepicker]="pickerDateOfPickup" formControlName="dateOfPickup" placeholder="MM/DD/YYYY" required>
              <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfPickup"></mat-datepicker-toggle>
              <mat-datepicker #pickerDateOfPickup></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="input-item">
            <app-input-field
              [label]="'Manager name'"
              [type]="'text'"
              [cssClass]="'input-fields'"
              formControlName="reportingManager"
              [disabled]="true"
            ></app-input-field>
          </div>
          <div class="input-item">
            <app-input-field
              [label]="'Leader Name'"
              [type]="'text'"
              [cssClass]="'input-fields'"
              formControlName="dnTLeader"
              [disabled]="true"
            ></app-input-field>
          </div>
        </div>
        <div class="form-row">
          <div class="input-item status-container">
            <app-status-label
              [status]="DamageAnalyticsForm.get('damageCostStatus')?.value"
              [showDropdown]="true"
              [category]="'Damage'"
              (statusChange)="onStatusChange($event)"
              formControlName="damageCostStatus"
            ></app-status-label>
          </div>
        </div>
        <div class="text-area-container">
          <textarea
            matInput
            formControlName="comments"
            rows="4"
            class="text-area"
            placeholder="Comments"
          ></textarea>
        </div>

        <div
          class="section-field full-width attachment-field"
          (click)="$event.stopPropagation()"
        >
          <app-file-upload
            [label]="
              DamageAnalyticsForm.get('osType')?.value === 'MacBook' ||
              DamageAnalyticsForm.get('osType')?.value === 'mac' ||
              DamageAnalyticsForm.get('osType')?.value === 'Mac'
                ? 'Attachment*'
                : 'Attachment'
            "
            [selectedFile]="attachedFiles.length > 0 ? attachedFiles[0] : null"
            [existingFileUrl]="
              dialogData?.isEdit ? dialogData?.damageUrl || '' : ''
            "
            [fileName]="
              dialogData?.isEdit
                ? getFileNameFromUrl(dialogData?.damageUrl || '')
                : ''
            "
            (fileSelected)="onAttachmentSelected($event)"
            (fileRemoved)="onAttachmentRemoved()"
          >
          </app-file-upload>
          <div
            *ngIf="
              (DamageAnalyticsForm.get('osType')?.value === 'MacBook' ||
                DamageAnalyticsForm.get('osType')?.value === 'mac' ||
                DamageAnalyticsForm.get('osType')?.value === 'Mac') &&
              !(
                uploadedFileUrl ||
                (attachedFiles && attachedFiles.length > 0) ||
                (dialogData?.isEdit && dialogData?.damageUrl)
              )
            "
            class="file-error-message"
          >
            File attachment is required for MacBook devices
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="action-buttons">
      <app-button-group
        [label]="dialogData?.isEdit ? 'Close' : 'Cancel'"
        [buttonType]="'Secondary'"
        [cssClass]="'cancel-btn'"
        [buttonUseCase]="'cancel'"
        (click)="handleActionForm('cancel')"
      ></app-button-group>
      <app-button-group
        [label]="dialogData?.isEdit ? 'Save' : 'Submit'"
        [buttonUseCase]="dialogData?.isEdit ? 'saveEdit' : 'save'"
        [buttonType]="'Primary'"
        [disabled]="isFormInvalid()"
        (click)="handleActionForm(dialogData?.isEdit ? 'saveEdit' : 'save')"
      ></app-button-group>
    </div>
  </mat-dialog-actions>
</div>
